import { render, staticRenderFns } from "./blockLeftTop.vue?vue&type=template&id=66483254&scoped=true&"
import script from "./blockLeftTop.vue?vue&type=script&lang=js&"
export * from "./blockLeftTop.vue?vue&type=script&lang=js&"
import style0 from "./blockLeftTop.vue?vue&type=style&index=0&id=66483254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66483254",
  null
  
)

export default component.exports